/* eslint-disable no-restricted-imports */
/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { DpProductCardSearch } from '@/components/blocks/DpLibrary/DpProductCardSearch';
import { useProductEvents } from '@/data/Content/_ProductEvents';
import { ProductType } from '@/data/types/Product';
import { getImage } from '@/utils/getImage';
import { Grid } from '@mui/material';
import { calculateProductPrices } from 'integration/utils/calculateProductPrices';
import { formatPrice } from 'integration/utils/formatPrice';
import { FC, useMemo } from 'react';

interface InfoElectronico {
	offerDeContado?: string;
	strikedDeContado?: string;
}

export const ProductCardSearch: FC<{
	product: ProductType;
	infoElectronico?: InfoElectronico;
	clickAction?: () => void;
}> = ({ product, clickAction, infoElectronico }) => {
	const { onClick } = useProductEvents({ product });

	const { price, priceWithoutOffer, shouldOffer } = calculateProductPrices({
		list: product.productPrice.list || 0,
		offer: product.productPrice.offer || 0,
		ribbons: product?.ribbons ?? [],
	});

	const prices = useMemo(() => {
		if (infoElectronico) {
			return {
				discount: infoElectronico.strikedDeContado ? infoElectronico.offerDeContado : undefined,
				price: infoElectronico.strikedDeContado || infoElectronico.offerDeContado || '',
			};
		}

		return {
			price: priceWithoutOffer,
			discount: shouldOffer ? price : undefined,
		};
	}, [infoElectronico, price, priceWithoutOffer, shouldOffer]);

	return (
		<Grid onClick={onClick(clickAction)} id={product.partNumber} data-testid={product.partNumber}>
			<DpProductCardSearch
				seo={product.seo.href}
				title={product.name}
				category={'Calzado Hombre'}
				image={getImage(product.thumbnail)}
				price={formatPrice(prices.price, 'mxn')}
				colors={['#C0474A', '#C46D52', '#242424']}
				discount={prices.discount ? formatPrice(prices.discount, 'mxn') : undefined}
				ribbons={product?.ribbons ?? []}
			/>
		</Grid>
	);
};
